// Register service worker
async function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    try {
      // Add timestamp to prevent caching of service worker
      const swUrl = `/serviceWorker.js?v=4`;
      const registration = await navigator.serviceWorker.register(swUrl, {
        scope: "/",
        type: "module",
        updateViaCache: "none",
      });
      console.log("Service worker registered:", registration);

      // Check for updates
      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed") {
            // Clear caches and reload
            clearImageCache().then(() => {
              window.location.reload();
            });
          }
        });
      });
    } catch (error) {
      console.error("Service worker registration failed:", error);
    }
  }
}

// Initialize service worker
registerServiceWorker();

// Image loading with fallback and caching
export function getImageWithFallback(url, fallbackUrl) {
  if (!url) return fallbackUrl;

  // Add cache busting parameter for development
  if (process.env.NODE_ENV === "development") {
    const cacheBuster = `_cb=${Date.now()}`;
    url = url.includes("?") ? `${url}&${cacheBuster}` : `${url}?${cacheBuster}`;
  }

  return url;
}

// Preload critical images
export function preloadImages(urls) {
  urls.forEach((url) => {
    if (!url) return;
    const img = new Image();
    img.src = url;
  });
}

// Clear image cache
export async function clearImageCache() {
  if ("caches" in window) {
    try {
      await caches.delete("outlight-image-cache-v4");
      console.log("Image cache cleared");
    } catch (error) {
      console.error("Error clearing image cache:", error);
    }
  }
}
